import Vertex from "./vertex";
import Model from "./model";
import GraphEvent from "./event";
import State from "./state";
import View from "./view";
import Point from "./point";
import Geometry from "./geometry";
import Rectangle from "./rectangle";

export default class Graph {
    model: Model;
    absolute: boolean = false;
    view: View;
    constrain: any;
    source: null;
    target: null;
    width: number;
    height: number;
    padding: number;

    constructor(model: Model, width: number, height: number, padding: number) {
        this.model = model;
        this.height = height;
        this.width = width;
        this.padding = padding;
        this.view = new View(this);
    }

    public getPadding(): number {
        return this.padding;
    }

    public getWidth(): number {
        return this.width;
    }

    public getHeight(): number {
        return this.height;
    }
    
    fireEvent(arg0: any): any {
        console.log(arg0)
    }

    cellsAdded(cells: Vertex[], parent: Vertex, index: number, arg3: null, arg4: null, arg5: boolean): void {
        if (cells != null && parent != null && index != null)
		{
			this.model.beginUpdate();
			try
			{
				let parentState: State | null = (this.absolute) ? this.view.getState(parent) : null;
				let o1: Point | null = (parentState != null) ? parentState.getOrigin() : null;
				let zero: Point = new Point(0, 0);

				for (let i = 0; i < cells.length; i++)
				{
					if (cells[i] == null)
					{
						index--;
					}
					else
					{
						this.model.add(cells[i]);

						// Extends the parent
						if (this.isExtendParentsOnAdd() && this.isExtendParent(cells[i]))
						{
							this.extendParent(cells[i]);
						}

						// Constrains the child
						if (this.constrain)
						{
							this.constrainChild(cells[i]);
						}

					
					}
				}

				this.fireEvent(new GraphEvent("CELLS_ADDED", cells, 0, 0));

			}
			finally
			{
				this.model.endUpdate();
			}
		}
    }
    
    isResetEdgesOnConnect(): boolean {
        return false;
    }
    setConnectionConstraint(edge: Vertex, terminal: null, source: boolean, constraint: null): any {
        
    }
    isPortsEnabled(): any {
        return false;
    }
    constrainChild(arg0: Vertex): any {
        
    }
    extendParent(arg0: Vertex): any {
        
    }
    isExtendParent(arg0: Vertex): any {
        return false;
    }
    isExtendParentsOnAdd(): any {
        return false;
    }
    setAllowNegativeCoordinates(previous: boolean): any {
        
    }
    cellsMoved(cells: Vertex[], dx: number, dy: number, disconnect: boolean, constrain: boolean): any {
        if (cells != null && (dx != 0 || dy != 0))
		{
			this.model.beginUpdate();
			try
			{
				if (disconnect)
				{
					this.disconnectGraph(cells);
				}

				for (var i = 0; i < cells.length; i++)
				{
					this.translateCell(cells[i], dx, dy);

					if (constrain)
					{
						this.constrainChild(cells[i]);
					}
				}

				this.fireEvent(new GraphEvent("CELLS_MOVED", cells, dx, dy));
			}
			finally
			{
				this.model.endUpdate();
			}
		}
    }
    
    isResetEdgesOnMove(): any {
        return false;
    }
    translateCell(cell: Vertex, dx: number, dy: number): any {
        let geo: Geometry | null = this.model.getGeometry(cell);

		if (geo != null)
		{
			geo = geo.clone();
			geo.translate(dx, dy);


			if (!geo.isRelative() && this.model.isVertex(cell) && !this.isAllowNegativeCoordinates())
			{
				geo.setX(Math.max(0, geo.getX()));
				geo.setY(Math.max(0, geo.getY()));
			}

			if (geo.isRelative() && !this.model.isEdge(cell))
			{
				if (geo.getOffset() == null)
				{
					geo.setOffset(new Point(dx, dy));
				}
				else
				{
					const offset: Point = geo.getOffset();

					offset.setX(offset.getX() + dx);
					offset.setY(offset.getY() + dy);
				}
			}

            this.model.setGeometry(cell, geo);
        }
    }
    disconnectGraph(cells: Vertex[]): any {
        
    }

    isAllowNegativeCoordinates(): boolean {
        return true;
    }
    snap(arg0: number): number {
        return arg0;
    }
    getOpposites(edges: Vertex[], terminal: Vertex): Vertex[] {        
        return Object.values(terminal.getEdges());        
    }
    resetEdge(edge: Vertex): any {
        let geo: Geometry | null = this.model.getGeometry(edge);

		if (geo != null)
		{
			// Resets the control points
			const points: Point[] = geo.getPoints();

			if (points != null && points.length > 0)
			{
				geo = geo.clone();
				geo.setPoints(null);
				this.model.setGeometry(edge, geo);
			}
		}

		return edge;
    }
    getBoundsForCells(cells: any[], includeEdges: boolean, includeDescendants: boolean, boundingBox: boolean): Rectangle | null {
        let result: Rectangle | null = null;

		if (cells != null && cells.length > 0)
		{
			for (let i = 0; i < cells.length; i++)
			{
				let tmp: Rectangle = this.getCellBounds(cells[i], includeEdges, includeDescendants, boundingBox);

				if (tmp != null)
				{
					if (result == null)
					{
						result = tmp;
					}
					else
					{
						result.add(tmp);
					}
				}
			}
		}

		return result;
    }
    getCellBounds(cell: Vertex, includeEdges: boolean, includeDescendants: boolean, boundingBox: boolean): Rectangle {
        let cells: Vertex[] = [];

		// Recursively includes connected edges
		if (includeEdges)
		{
			const allCells: { [id:string]: Vertex} = {};
            allCells[cell.getId()] = cell;

            let edges: { [id:string]: Vertex} = {};
            
            this.getEdges(cell).forEach(edge => {
                edges[edge.getId()] = edge;
            })

			while (Object.keys(edges).length > 0)
			{
                Object.values(edges).forEach(edge => {
                    allCells[edge.getId()] = edge;
                });
                                
                const tmp: { [id:string]: Vertex} = {};
				
                Object.values(edges).forEach(edge => {
                    this.getEdges(edge).forEach(other => {
                        if (!(other.getId() in allCells)) {
                            tmp[other.getId()] = other;
                        }
                    });
                });

				edges = tmp;
			}

			cells = Object.values(allCells);
		}
		else
		{
            cells = new Array();
            cells.push(cell);
		}

        
		const result: Rectangle = this.view.getBounds(cells, boundingBox);

		return result;
    }
    getEdges(cell: Vertex): Vertex[] {
        return Object.values(cell.getEdges());
    }
    
    getModel(): Model {
        return this.model;
    }
    getConnections(vertex: any, parent: any): Vertex[] {
        return this.getEdges(vertex);
    }

}
